import React from 'react';
import composeClassNames from '../../../../../utils/composeClassNames';

import './Switch.css';

const LABEL_PLACEMENT_START = 'start';

export default function Switch({
    checked = false,
    onChange,
    label,
    labelPlacement,
    disabled = false,
    className,
}) {
    const isLabelFirst = labelPlacement === LABEL_PLACEMENT_START;

    const classNames = composeClassNames([
        'Switch',
        isLabelFirst ? 'Switch--label-start' : null,
        disabled ? 'Switch--disabled' : null,
        className,
    ]);

    const labelNode = label ? (
        <span className="Switch__label">{label}</span>
    ) : null;

    const control = (
        <span className="switch">
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange && onChange(event.target.checked)}
            />
            <span className="slider round" />
        </span>
    );

    return (
        <label className={classNames}>
            {isLabelFirst ? labelNode : null}
            {control}
            {isLabelFirst ? null : labelNode}
        </label>
    );
}
